import { LineChart, Line, ResponsiveContainer } from 'recharts';

type Props = {
  values: number[];
  positive: boolean | null;
};

/**
 * Tiny in-row chart of the last 30 closes. Colors follow the 30d % trend
 * (green positive, red negative, muted when undetermined) so the visual
 * direction matches the numeric badge next to it.
 */
export function Sparkline({ values, positive }: Props) {
  if (!values || values.length < 2) return null;
  const color =
    positive === null ? 'var(--text-subtle)' :
    positive ? 'var(--accent)' : 'var(--accent-danger)';
  const data = values.map((v) => ({ v }));
  return (
    <div className="w-24 h-8">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
          <Line
            type="monotone"
            dataKey="v"
            stroke={color}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
